import { Route } from "react-router";
import { Routes } from "react-router-dom";
import { PreserveSearchNavigate } from "../../components/Navigate/PreserveSearchNavigate.tsx";
import {
  HOME_BRAND_KIT,
  HOME_CHARACTERS,
  HOME_OBJECTS,
  HOME_PROJECTS,
  HOME_STYLES,
  PURCHASES,
} from "../../routes.ts";
import {
  CHARACTER_MODEL_TYPE,
  OBJECT_MODEL_TYPE,
  STYLE_MODEL_TYPE,
} from "../constants.ts";
import { BrandKitView } from "./BrandKit/BrandKitView.tsx";
import { BoardsView } from "./HomeIndex/Board/BoardsView.tsx";
import { HomeIndex } from "./HomeIndex/HomeIndex.tsx";
import { ModelsView } from "./HomeIndex/Model/ModelsView.tsx";
import { HomeSidebar } from "./HomeSidebar/HomeSidebar.tsx";
import { PurchasedView } from "./Purchased/PurchasedView.tsx";
import { QuickActionsDialog } from "./QuickActions/QuickActionsDialog.tsx";

export const HomeView = () => (
  <div className="flex-fill w-full flex-row">
    <QuickActionsDialog />
    <HomeSidebar />
    <div className="flex-fill h-full">
      <Routes>
        <Route index element={<HomeIndex />} />
        <Route path={HOME_PROJECTS} element={<BoardsView />} />
        <Route path={HOME_BRAND_KIT} element={<BrandKitView />} />
        <Route
          path={HOME_STYLES}
          element={<ModelsView modelType={STYLE_MODEL_TYPE} />}
        />
        <Route
          path={HOME_CHARACTERS}
          element={<ModelsView modelType={CHARACTER_MODEL_TYPE} />}
        />
        <Route
          path={HOME_OBJECTS}
          element={<ModelsView modelType={OBJECT_MODEL_TYPE} />}
        />
        <Route path={PURCHASES} element={<PurchasedView />} />
        <Route path="*" element={<PreserveSearchNavigate replace to="" />} />
      </Routes>
    </div>
  </div>
);
